// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a70e38a5","455":"c07e5431"}[chunkId] + ".chunk.js";
};